<ng-template #tabContent>
    <ng-content></ng-content>
</ng-template>